'use strict';

/**
 * View for rendering the talks/contacts for the drag and drop
 *
 * @category   View
 * @module     entities
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var CollectionView = require('base/Colido.CollectionView');
var NavigationTalksItemView = require('./navigation-talks-dnd-list-item');

var NavigationTalksDndListView = CollectionView.extend({
    tagName: 'ul',
    className: 'navigation-talks-dnd-list',
    childView: NavigationTalksItemView,
    childViewOptions: function() {
        return {
            talkType: this.getOption('talkType'),
        };
    },

    collectionEvents: {
        'add remove reset sync': 'render',
    },
});

module.exports = NavigationTalksDndListView;